import errorManager from '@/rollbar.js';

var CreateSelect2, init, initEl;
CreateSelect2 = function (obj) {
  this.obj = $(obj);
  if (this.obj.hasClass('select2-hidden-accessible') && !this.obj.hasClass('myinput-xxlarge')) {
    return;
  }
  this.css_class = obj.attr('data-css');
  this.max_result_for_search = obj.attr('data-max-result');
  this.placeholder = obj.attr('data-placeholder') || window.i18nJS.clic_per_selezionare;
  this.css_container = obj.attr('data-container');
  this.templateResultCallback = obj.attr('data-t-result') ? Utils.getFunctionByName(obj.attr('data-t-result')) : this.genericTemplate;
  this.templateSelectionCallback = obj.attr('data-t-selection')
    ? Utils.getFunctionByName(obj.attr('data-t-selection'))
    : this.genericTemplate;
  this.allow_clear = obj.attr('data-allow-clear') || true;
  this.options = {
    language: window.locale_s(),
    allowClear: this.allow_clear,
    width: 'element',
    placeholder: this.placeholder,
    dropdownCssClass: this.css_class,
    containerCssClass: this.css_container,
    minimumResultsForSearch: this.max_result_for_search ? this.max_result_for_search : 9,
    theme: 'bootstrap',
    templateResult: this.templateResultCallback,
    templateSelection: this.templateSelectionCallback,
  };
  if ($('body').hasClass('mobile')) {
    // Applichiamo proprietà specifiche per mobile
    this.options.dropdownAutoWidth = true;
    this.options.dropdownParent = this.obj.parent();
    this.options.dropdownPosition = 'auto';
  }
  if (obj.attr('data-ajax--url')) {
    this.options['ajax'] = {
      delay: 1000,
      dataType: 'json',
      cache: true,
      data: function (params) {
        return {
          term: params.term,
          page: params.page,
        };
      },
      processResults: function (data, params) {
        var more;
        more = !(data.length < 10);
        return {
          results: data,
          pagination: {
            more: more,
          },
        };
      },
    };
  }
  this.bind();
};

let openSelect2Count = 0;

CreateSelect2.prototype = {
  constructor: CreateSelect2,
  bind: function () {
    var self = this;

    this.obj.select2(this.options);

    let scrollBlocked = false;

    this.obj.on('select2:open', function (e) {
      if ($('body').hasClass('mobile')) {
        openSelect2Count++;
        if (!scrollBlocked) {
          scrollBlocked = true;
          $('body').css('overflow', 'hidden');
        }

        const offset = self.obj.offset().top;
        const headerOffset = 50;

        $('html, body').animate(
          {
            scrollTop: offset - headerOffset,
          },
          300,
        );
      }
    });

    this.obj.on('select2:close', function (e) {
      if ($('body').hasClass('mobile')) {
        openSelect2Count--;

        if (openSelect2Count < 0) {
          openSelect2Count = 0;
        }

        if (openSelect2Count === 0 && scrollBlocked) {
          scrollBlocked = false;
          $('body').css('overflow', '');
        }
      }
    });

    $('.select2-dropdown').on('touchmove', function (e) {
      e.stopPropagation();
    });
  },
  genericTemplate: function (item) {
    if (item.hasOwnProperty('description') && item.hasOwnProperty('matricola') && item.hasOwnProperty('cod')) {
      return item.description.toUpperCase() + ' cod: ' + item.cod + ' matr: ' + item.matricola;
    } else if (item.hasOwnProperty('desc_and_icd9')) {
      return item.desc_and_icd9;
    } else if (item.hasOwnProperty('description') && item.hasOwnProperty('cod')) {
      if (item.cod) {
        return item.description.toUpperCase() + ' (' + item.cod.toUpperCase() + ')';
      } else {
        return item.description.toUpperCase();
      }
    } else if (item.hasOwnProperty('surname') && item.hasOwnProperty('firstname')) {
      if (item.nr_cartella) {
        return item.surname + ' ' + item.firstname + ' (' + item.nr_cartella + ')';
      } else {
        return item.surname + ' ' + item.firstname;
      }
    } else if (item.hasOwnProperty('description')) {
      return item.description;
    } else if (item.hasOwnProperty('label')) {
      return item.label;
    } else {
      return item.text;
    }
  },
};

const createSelect2Instance = (el) => {
  console.log('createSelect2Instance');
  try {
    return new CreateSelect2($(el));
  } catch (e) {
    errorManager(e);
  }
};

init = function () {
  $('.chzn-select2').each(function () {
    return createSelect2Instance(this);
  });
  return window.eventBus.$emit('select2init', null);
};

initEl = function (el) {
  return createSelect2Instance(el);
};

window.CreateSelect2 = {
  init: init,
  initEl: initEl,
};
